import memo from "set-state-compare/build/memo"
import ReactDOM from "react-dom"

const bodyPortal = memo((props) => {
  return ReactDOM.createPortal(
    props.children,
    document.getElementById("react-body-portal")
  )
})

export default bodyPortal
